import { Routes, Route, Navigate, useParams } from "react-router-dom";
import withTenant from "./utils/withTenant";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import NotFound from "./pages/NotFound";
import TokenRedirect from "./pages/TokenRedirect";
import Logout from "./pages/Logout";
import DashBoard from "./pages/DashBoard";

import HeaderNavBar from "./layout/HeaderNavBar";
import Footer from "./layout/Footer";
import MenuSide from "./layout/MenuSide";

import withGuard from "./utils/withGuard";
import { useTenant, useStartup } from "./hooks";
import { MwSpinner } from "./components/ui";
import { NoPermission } from "./components/ui";
import "./index.css";
import Settings from "./pages/Settings";
import VATFilingReport from "./pages/Vatfilingreport";
import NotificationBar from "./layout/NotificationBar";
import { AccountSettingsProvider } from "./contexts/AccountSettingsContext";
import { useAppsHome } from "./data/AbsatApps";
import { userHasAppAccess } from "./utils/appAccess";

function TenantRootRedirect() {
  const { tenant } = useParams();

  if (!tenant) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/${tenant}`} replace />;
}

function VATFilingReportRoute() {
  const authUser = useSelector((state) => state.auth?.user);
  const user = useMemo(() => {
    if (authUser) return authUser;
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  }, [authUser]);
  const { apps, loadingApps } = useAppsHome();
  const canViewVatFilingReport = userHasAppAccess(user, apps, "sales")
    && userHasAppAccess(user, apps, "purchases");

  if (loadingApps) return <MwSpinner />;
  if (!canViewVatFilingReport) return <NoPermission />;

  return <VATFilingReport />;
}

function ProtectedApp({ isShowLicense }) {
  const [openMenu, setOpenMenu] = useState(false);
  const langState = useSelector((state) => state.lang);
  const {
    tenant,
    tenantUsername,
    loading: loadingTenant,
    companiesList,
    branchesList,
    tenantId,
    companySelected,
    branchSelected,
  } = useTenant();
  const { startup } = useStartup();
  return (
    <AccountSettingsProvider>
      {!loadingTenant && startup ? (
        <div
          dir={langState?.value === "ar" ? "rtl" : "ltr"}
          className="h-screen flex flex-col overflow-hidden"
        >
      <div className="bg-[#251658] flex flex-col flex-1 w-full overflow-hidden">
        <NotificationBar />
        <HeaderNavBar
          companySelected={companySelected}
          branchSelected={branchSelected}
          companiesList={companiesList}
          branchesList={branchesList}
          tenantUsername={tenantUsername}
          tenant={tenant}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
        />
        {/* القائمة الجانبية */}
        <MenuSide openMenu={openMenu} setOpenMenu={setOpenMenu} />
        {/* منطقة المحتوى الأبيض */}
        <div
          className={`flex flex-col md:w-[96.5%]  ms-auto  w-[90%] flex-1 p-1 overflow-hidden ${openMenu ? "md:ms-10" : "md:ms-10"
            }`}
        >
          <div
            className="rounded-2xl bg-white border border-white border-[5px] flex-1 overflow-auto"
            style={{
              minHeight:
                "calc(100vh - var(--header-height, 56px) - var(--notification-height, 0px) - var(--footer-height, 28px))",
              maxHeight:
                "calc(100vh - var(--header-height, 56px) - var(--notification-height, 0px) - var(--footer-height, 28px))",
            }}
          >
          <Routes>
  <Route path="/" element={<DashBoard />} />
  <Route path=":tenant/" element={<DashBoard />} />
  <Route path=":tenant/dashboard" element={<TenantRootRedirect />} />
  <Route path=":tenant/token/:token" element={<TokenRedirect />} />
  <Route path=":tenant/logout" element={<Logout />} />
  <Route path=":tenant/settings" element={<Settings />} />
  <Route path=":tenant/vat-filing-report" element={<VATFilingReportRoute />} />  {/* ← الجديد */}
  <Route path="/notfound" element={<NotFound />} />
  <Route path="/*" element={<NotFound />} />
</Routes>
          </div>
        </div>
      </div>

      <footer className="w-full bg-[#251658] text-white py-4 text-center">
        <Footer />
      </footer>
    </div>
  ) : (
    <MwSpinner />
  )}
    </AccountSettingsProvider>
  );
}

function App(props) {
  return <ProtectedApp {...props} />;
}

export default withTenant(withGuard(App));
